import { FirebaseAnalytics } from "@capacitor-firebase/analytics";

export type FirebaseClientDependencies = {
  analytics?: typeof FirebaseAnalytics;
};

export const createFirebaseClient = (
  dependencies: FirebaseClientDependencies = {}
) => {
  const analytics = dependencies.analytics || FirebaseAnalytics;
  return {
    start: () => analytics.setEnabled({ enabled: true }),
    identify: (userId: string) => analytics.setUserId({ userId }),
    clearIdentity: () => analytics.setUserId({ userId: null }),
    setProperty: (key: string, value: string) =>
      analytics.setUserProperty({ key, value }),
    track: (name: string, params: Record<string, string | number | boolean>) =>
      analytics.logEvent({ name, params }),
    getInstanceId: async (): Promise<string | null> =>
      (await analytics.getAppInstanceId()).appInstanceId || null,
  };
};

export type FirebaseClient = ReturnType<typeof createFirebaseClient>;
